import _ from 'lodash';
import { vault } from '../../actions/actionTypes';
export const initialState = {
    recents: { id: 'recents', name: 'Recents', timestamp: 0 },
};
export default function (state = initialState, action) {
    switch (action.type) {
        case vault.FETCH_VAULT_ALBUMS:
            const fetchVaultAlbumsPayload = action.payload;
            if (fetchVaultAlbumsPayload.firstFetch) {
                return { ...initialState, ..._.mapKeys(fetchVaultAlbumsPayload.albums, 'timestamp') };
            }
            return { ...state, ..._.mapKeys(fetchVaultAlbumsPayload.albums, 'timestamp') };
        case vault.LOGOUT_ALBUMS:
            return initialState;
        default:
            return state;
    }
}
